import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { AddResidentData } from '../AddResidentForm';
import { Input } from '@/shared';

// ---------------------------- Step 1 ----------------------------
interface ResidentInfoProps {
  register: UseFormRegister<AddResidentData>;
  errors: FieldErrors<AddResidentData>;
}

export const ResidentInformationForm: React.FC<ResidentInfoProps> = ({
  register,
  errors,
}) => (
  <>
    <Input
      label="Full Name"
      {...register('fullName')}
      error={errors.fullName?.message}
    />
    <Input
      label="Phone Number"
      {...register('phone')}
      error={errors.phone?.message}
    />
    <Input
      label="Email Address"
      {...register('email')}
      error={errors.email?.message}
    />
  </>
);
